/** `items` with the one at `fromId` moved to where `toId` sits. Unknown ids
 *  leave the list as it is. */
export function moveById<T extends { id: string }>(items: T[], fromId: string, toId: string): T[] {
  const from = items.findIndex((item) => item.id === fromId);
  const to = items.findIndex((item) => item.id === toId);
  if (from === -1 || to === -1 || from === to) return items;
  const next = [...items];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved!);
  return next;
}

/** `moveById` for a plain list of keys. */
export function moveKey(keys: string[], fromKey: string, toKey: string): string[] {
  return moveById(
    keys.map((id) => ({ id })),
    fromKey,
    toKey,
  ).map(({ id }) => id);
}
